import Vue from "vue";
import Router from "vue-router";
import NcpMap from "@/components/NcpMap";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "NcpMap",
      component: NcpMap
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js